module.exports = __webpack_public_path__ + "static/img/router.0292632.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/router.svg
// module id = 1454
// module chunks = 4